import { useEffect } from 'react';

export const useKeyboardShortcut = (
  key: string,
  callback: (e: KeyboardEvent) => void,
  options?: {
    ctrlKey?: boolean;
    metaKey?: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
  }
) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Pour Cmd+K (Mac) ou Ctrl+K (Windows/Linux)
      // On accepte soit metaKey (Mac) soit ctrlKey (Windows/Linux)
      const isModifierPressed = options?.metaKey 
        ? (e.metaKey || e.ctrlKey) // Accepter Cmd ou Ctrl pour compatibilité cross-platform
        : options?.ctrlKey 
        ? e.ctrlKey 
        : true;
      
      const shiftMatch = options?.shiftKey !== undefined ? e.shiftKey === options.shiftKey : !e.shiftKey;
      const altMatch = options?.altKey !== undefined ? e.altKey === options.altKey : !e.altKey;

      // Vérifier que e.key existe avant d'appeler toLowerCase()
      if (
        e.key &&
        e.key.toLowerCase() === key.toLowerCase() &&
        isModifierPressed &&
        shiftMatch &&
        altMatch
      ) {
        // Empêcher le comportement par défaut du navigateur
        e.preventDefault();
        callback(e);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [key, callback, options]);
};

